export const SAVE_MODAL_ACTIONS = {
  SAVE: 'save',
  PROCEED: 'proceed',
  CLOSE: 'close'
}
